import React from 'react';

const PageHeader = ({ eyebrow, title, subtitle, image }) => {
  const bg = image || 'https://images.unsplash.com/photo-1618556450994-a6a128ef0d9d?auto=format&fit=crop&w=3840';
  return (
    <section className="relative pt-40 pb-24 md:pt-48 md:pb-32 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url('${bg}')` }}
      />
      <div className="absolute inset-0 bg-black/65" />
      <div className="relative max-w-5xl mx-auto px-6 lg:px-10 text-center">
        {eyebrow && (
          <p className="text-white/70 text-xs uppercase tracking-[0.35em] mb-4">{eyebrow}</p>
        )}
        <h1 className="font-serif text-white text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-6 text-white/85 text-lg md:text-xl max-w-2xl mx-auto font-light">
            {subtitle}
          </p>
        )}
        <div className="mt-8 mx-auto w-16 h-px bg-white" />
      </div>
    </section>
  );
};

export default PageHeader;
